import styled from 'styled-components';

export const MobileAccountBlockStyled = styled.div`
    .sum-pl {
        background: rgba(129, 146, 228, 0.1);
        border-radius: 12px;
        padding: 6px 12px;

        font-weight: 600;
        display: inline-block;
    }

    .pl-diff {
        svg {
            margin-left: 8px;
            margin-right: -4px;
        }
    }

    .pl-diff-period {
        color: var(--color-secondary);
        font-size: 14px;
        line-height: 20px;
        margin: 0 8px;
    }

    .equity-pl {
        margin-left: 12px;
    }
`;

export const MobileAccountTopBoxStyled = styled.div`
    background-color: var(--color-background-primary);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 16px;
    z-index: 3;
    width: 100%;
    box-shadow: 0 0 25px rgb(0 0 0 / 25%);
    transition: all 0.5s ease-in-out;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .equity {
        font-weight: 700;
        font-size: 16px;
    }
`;

export const MobileAccountStatButtonWrapperStyled = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    padding: 12px;
    
    svg {
        color: var(--color-secondary);
    }
`;

export const MobileAccountBoxStyled = styled.div`
    position: relative;
    background-color: var(--color-surface);
    border-radius: 16px;
    padding: 12px;

    h1 {
        padding: 0 8px;
        margin-bottom: 16px;
        font-size: 40px;
        line-height: 48px;
    }
`;

export const MobileAccountBoxButtonTextStyled = styled.div`
    margin-bottom: 12px;
` ;

export const MobileAccountBoxEquitySkeletonStyled = styled.div`
    height: 48px;
    width: 250px;
    border-radius: 12px;
`;

export const MobileAccountBoxHeaderButtonSkeletonStyled = styled.div`
    height: 40px;
    width: 40px;
    border-radius: 36px;
`;

export const MobileAccountStatButtonSkeletonStyled = styled.div`
    height: 48px;
    width: 48px;
    border-radius: 8px;
`;

export const MobileAccountBoxHeaderButtonsStyled = styled.div`
    display: flex;
    gap: 4px;
    color: var(--color-white-95);
`;
